<template>
  <div class="box">
    <table width="430">
      <tr>
        <td width="60" align="right">
          <label for="title">标题：</label>
        </td>
        <td>
          <input id="title" v-model="data.title" />
        </td>
      </tr>
      <tr>
        <td align="right">
          <label class="content-label">合作商：</label>
        </td>
        <td>
          <div class="image-box">
            <div v-for="(item, index) in data.imageList" :key="index" class="image-uploads" @click="uploadShow = true, idx = index">
              <div class="image-uploads-img">
                <img v-if="item.src" :src="item.src" />
                <img v-else src="../../assets/image-upload.jpg" style="background-color: #dddee1" />
              </div>
              <i class="del-icon el-icon-delete" @click="(e)=>{handleDeleteImg(e,index)}"></i>
            </div>

          </div>
          <div class="image-btn-add" @click="handleAddBtnClick">+</div>
        </td>
      </tr>
    </table>

    <imgPre v-if="uploadShow" :dialogVisible="uploadShow" @checkImg="handleImg" @onClose="uploadShow = false" />
  </div>
</template>
<script>
import imgPre from '../../components/uploadImg/imgPre'
export default {
  name: 'CompanyPartnerSetting',
  components: { imgPre },
  props: {
    data: Object
  },
  data () {
    return {
      uploadShow: false,
      idx: 0
    }
  },
  methods: {
    handleAddBtnClick: function () {
      this.data.imageList.push('')
    },
    handleImg: function (data) {
      this.data.imageList[this.idx].src = data.url
      console.log('哈哈哈哈', this.data.imageList)
      this.uploadShow = false
    },
    handleDeleteImg: function (e, index) {
      e.stopPropagation()
      this.data.imageList.splice(index, 1)
    },
    handleAvatarSuccess: function () {
      console.log()
    }
  }
}
</script>
<style scoped>
label {
  font-size: 13px;
}

.content-label {
  vertical-align: top;
}

.box {
  padding-top: 20px;
}

table {
  margin: 0 auto;
}

#title {
  width: 340px;
  margin-bottom: 5px;
}

.image-box {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  padding-top: 20px;
}
.image-uploads {
  width: 100px;
  height: 100px;
  position: relative;
  padding: 5px;
  border-radius: 4px;
  background-color: rgb(221, 222, 225);
}

.image-uploads-img {
  width: 100%;
  height: 100%;
}

.image-uploads img {
  width: 100%;
  height: 100%;
}

.image-uploads .image-uploads-img:hover::after {
  content: '点击上传';
  display: block;
  width: 90px;
  height: 90px;
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
  text-align: center;
  line-height: 90px;
  margin: 5px;
}

.image {
  float: left;
  margin: 0px 20px 20px 0;
}

.image-btn-add {
  float: left;
  height: 100px;
  line-height: 100px;
  text-align: center;
  width: 100px;
  border-radius: 5px;
  border: 1px dotted #58b7ff;
  font-size: 20px;
  cursor: pointer;
}
.del-icon {
  position: absolute;
  right: 0;
  top: 0;
  cursor: pointer;
  z-index: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/companyPartner/CompanyPartnerSetting.vue